import React from 'react';

import HeroSection from './landing/HeroSection';
import FeaturesSection from './landing/FeaturesSection';
import HowItWorksSection from './landing/HowItWorksSection';
//import StatsSection from './landing/StatsSection';
import PricingSection from './landing/PricingSection';
import CTASection from './landing/CTASection';
import Footer from './landing/Footer';
import LandingRotator from './landing/LandingRotator';
import LandingSkill from './landing/LandingSkill';
//import Navbar from './common/Navbar';

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-white dark:bg-gray-900">
      {/* 네비게이션 */}
      {/* <Navbar /> */}

      {/* <HeroSection /> */}
      <LandingRotator />

      {/* 히어로 섹션 */}
      <LandingSkill />
      {/* 주요 기능 */}
      <section id="features">
        <FeaturesSection />
      </section>

      {/* 작동 방식 */}
      <section id="how-it-works">
        <HowItWorksSection />
      </section>

      {/* 가격 플랜 */}
      {/* <section id="pricing">
        <PricingSection />
      </section> */}

      {/* CTA */}
      <CTASection />

      {/* Footer */}
      <section id="contact">
        <Footer />
      </section>
    </div>
  );
}
